"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
require("core-js/modules/es6.array.filter.js");
var _gAxios = _interopRequireWildcard(require("@gravity/g-axios"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_1iax2wxgii() {
  var path = "/codebuild/output/src1603853905/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/config/lib/actions.js";
  var hash = "00d2d68fb1ad5f40199cac2c57805c7277dc528b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1603853905/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/config/lib/actions.js",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 28
        },
        end: {
          line: 5,
          column: 2
        }
      },
      "1": {
        start: {
          line: 3,
          column: 35
        },
        end: {
          line: 5,
          column: 1
        }
      },
      "2": {
        start: {
          line: 7,
          column: 29
        },
        end: {
          line: 10,
          column: 2
        }
      },
      "3": {
        start: {
          line: 7,
          column: 38
        },
        end: {
          line: 10,
          column: 1
        }
      },
      "4": {
        start: {
          line: 12,
          column: 27
        },
        end: {
          line: 15,
          column: 2
        }
      },
      "5": {
        start: {
          line: 12,
          column: 36
        },
        end: {
          line: 15,
          column: 1
        }
      },
      "6": {
        start: {
          line: 17,
          column: 22
        },
        end: {
          line: 20,
          column: 2
        }
      },
      "7": {
        start: {
          line: 17,
          column: 31
        },
        end: {
          line: 20,
          column: 1
        }
      },
      "8": {
        start: {
          line: 21,
          column: 24
        },
        end: {
          line: 24,
          column: 2
        }
      },
      "9": {
        start: {
          line: 21,
          column: 33
        },
        end: {
          line: 24,
          column: 1
        }
      },
      "10": {
        start: {
          line: 25,
          column: 32
        },
        end: {
          line: 29,
          column: 2
        }
      },
      "11": {
        start: {
          line: 25,
          column: 64
        },
        end: {
          line: 29,
          column: 1
        }
      },
      "12": {
        start: {
          line: 31,
          column: 29
        },
        end: {
          line: 34,
          column: 2
        }
      },
      "13": {
        start: {
          line: 31,
          column: 38
        },
        end: {
          line: 34,
          column: 1
        }
      },
      "14": {
        start: {
          line: 41,
          column: 13
        },
        end: {
          line: 79,
          column: 1
        }
      },
      "15": {
        start: {
          line: 41,
          column: 53
        },
        end: {
          line: 79,
          column: 1
        }
      },
      "16": {
        start: {
          line: 43,
          column: 2
        },
        end: {
          line: 43,
          column: 34
        }
      },
      "17": {
        start: {
          line: 45,
          column: 2
        },
        end: {
          line: 48,
          column: 3
        }
      },
      "18": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 53
        }
      },
      "19": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 28
        }
      },
      "20": {
        start: {
          line: 50,
          column: 25
        },
        end: {
          line: 50,
          column: 60
        }
      },
      "21": {
        start: {
          line: 51,
          column: 2
        },
        end: {
          line: 53,
          column: 3
        }
      },
      "22": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 52,
          column: 66
        }
      },
      "23": {
        start: {
          line: 55,
          column: 2
        },
        end: {
          line: 78,
          column: 7
        }
      },
      "24": {
        start: {
          line: 63,
          column: 6
        },
        end: {
          line: 67,
          column: 7
        }
      },
      "25": {
        start: {
          line: 64,
          column: 22
        },
        end: {
          line: 64,
          column: 75
        }
      },
      "26": {
        start: {
          line: 65,
          column: 8
        },
        end: {
          line: 65,
          column: 45
        }
      },
      "27": {
        start: {
          line: 66,
          column: 8
        },
        end: {
          line: 66,
          column: 29
        }
      },
      "28": {
        start: {
          line: 68,
          column: 6
        },
        end: {
          line: 68,
          column: 21
        }
      },
      "29": {
        start: {
          line: 71,
          column: 19
        },
        end: {
          line: 71,
          column: 21
        }
      },
      "30": {
        start: {
          line: 72,
          column: 6
        },
        end: {
          line: 74,
          column: 7
        }
      },
      "31": {
        start: {
          line: 73,
          column: 8
        },
        end: {
          line: 73,
          column: 42
        }
      },
      "32": {
        start: {
          line: 75,
          column: 6
        },
        end: {
          line: 75,
          column: 41
        }
      },
      "33": {
        start: {
          line: 76,
          column: 6
        },
        end: {
          line: 76,
          column: 110
        }
      },
      "34": {
        start: {
          line: 77,
          column: 6
        },
        end: {
          line: 77,
          column: 22
        }
      },
      "35": {
        start: {
          line: 81,
          column: 21
        },
        end: {
          line: 106,
          column: 1
        }
      },
      "36": {
        start: {
          line: 81,
          column: 27
        },
        end: {
          line: 106,
          column: 1
        }
      },
      "37": {
        start: {
          line: 83,
          column: 2
        },
        end: {
          line: 83,
          column: 34
        }
      },
      "38": {
        start: {
          line: 85,
          column: 2
        },
        end: {
          line: 105,
          column: 7
        }
      },
      "39": {
        start: {
          line: 94,
          column: 6
        },
        end: {
          line: 98,
          column: 7
        }
      },
      "40": {
        start: {
          line: 95,
          column: 22
        },
        end: {
          line: 95,
          column: 75
        }
      },
      "41": {
        start: {
          line: 96,
          column: 8
        },
        end: {
          line: 96,
          column: 45
        }
      },
      "42": {
        start: {
          line: 97,
          column: 8
        },
        end: {
          line: 97,
          column: 29
        }
      },
      "43": {
        start: {
          line: 99,
          column: 6
        },
        end: {
          line: 99,
          column: 21
        }
      },
      "44": {
        start: {
          line: 102,
          column: 6
        },
        end: {
          line: 102,
          column: 37
        }
      },
      "45": {
        start: {
          line: 103,
          column: 6
        },
        end: {
          line: 103,
          column: 110
        }
      },
      "46": {
        start: {
          line: 104,
          column: 6
        },
        end: {
          line: 104,
          column: 22
        }
      },
      "47": {
        start: {
          line: 110,
          column: 25
        },
        end: {
          line: 110,
          column: 118
        }
      },
      "48": {
        start: {
          line: 110,
          column: 36
        },
        end: {
          line: 110,
          column: 118
        }
      },
      "49": {
        start: {
          line: 110,
          column: 60
        },
        end: {
          line: 110,
          column: 118
        }
      },
      "50": {
        start: {
          line: 114,
          column: 23
        },
        end: {
          line: 115,
          column: 73
        }
      },
      "51": {
        start: {
          line: 114,
          column: 35
        },
        end: {
          line: 115,
          column: 73
        }
      },
      "52": {
        start: {
          line: 115,
          column: 2
        },
        end: {
          line: 115,
          column: 73
        }
      },
      "53": {
        start: {
          line: 120,
          column: 13
        },
        end: {
          line: 122,
          column: 1
        }
      },
      "54": {
        start: {
          line: 120,
          column: 25
        },
        end: {
          line: 122,
          column: 1
        }
      },
      "55": {
        start: {
          line: 121,
          column: 2
        },
        end: {
          line: 121,
          column: 36
        }
      },
      "56": {
        start: {
          line: 127,
          column: 15
        },
        end: {
          line: 129,
          column: 1
        }
      },
      "57": {
        start: {
          line: 127,
          column: 29
        },
        end: {
          line: 129,
          column: 1
        }
      },
      "58": {
        start: {
          line: 128,
          column: 2
        },
        end: {
          line: 128,
          column: 40
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 3,
            column: 28
          },
          end: {
            line: 3,
            column: 29
          }
        },
        loc: {
          start: {
            line: 3,
            column: 35
          },
          end: {
            line: 5,
            column: 1
          }
        },
        line: 3
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 29
          },
          end: {
            line: 7,
            column: 30
          }
        },
        loc: {
          start: {
            line: 7,
            column: 38
          },
          end: {
            line: 10,
            column: 1
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 12,
            column: 27
          },
          end: {
            line: 12,
            column: 28
          }
        },
        loc: {
          start: {
            line: 12,
            column: 36
          },
          end: {
            line: 15,
            column: 1
          }
        },
        line: 12
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 17,
            column: 22
          },
          end: {
            line: 17,
            column: 23
          }
        },
        loc: {
          start: {
            line: 17,
            column: 31
          },
          end: {
            line: 20,
            column: 1
          }
        },
        line: 17
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 21,
            column: 24
          },
          end: {
            line: 21,
            column: 25
          }
        },
        loc: {
          start: {
            line: 21,
            column: 33
          },
          end: {
            line: 24,
            column: 1
          }
        },
        line: 21
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 25,
            column: 32
          },
          end: {
            line: 25,
            column: 33
          }
        },
        loc: {
          start: {
            line: 25,
            column: 64
          },
          end: {
            line: 29,
            column: 1
          }
        },
        line: 25
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 31,
            column: 29
          },
          end: {
            line: 31,
            column: 30
          }
        },
        loc: {
          start: {
            line: 31,
            column: 38
          },
          end: {
            line: 34,
            column: 1
          }
        },
        line: 31
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 41,
            column: 13
          },
          end: {
            line: 41,
            column: 14
          }
        },
        loc: {
          start: {
            line: 41,
            column: 53
          },
          end: {
            line: 79,
            column: 1
          }
        },
        line: 41
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 41,
            column: 53
          },
          end: {
            line: 41,
            column: 54
          }
        },
        loc: {
          start: {
            line: 41,
            column: 77
          },
          end: {
            line: 79,
            column: 1
          }
        },
        line: 41
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 62,
            column: 10
          },
          end: {
            line: 62,
            column: 11
          }
        },
        loc: {
          start: {
            line: 62,
            column: 22
          },
          end: {
            line: 69,
            column: 5
          }
        },
        line: 62
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 70,
            column: 11
          },
          end: {
            line: 70,
            column: 12
          }
        },
        loc: {
          start: {
            line: 70,
            column: 23
          },
          end: {
            line: 78,
            column: 5
          }
        },
        line: 70
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 81,
            column: 21
          },
          end: {
            line: 81,
            column: 22
          }
        },
        loc: {
          start: {
            line: 81,
            column: 27
          },
          end: {
            line: 106,
            column: 1
          }
        },
        line: 81
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 81,
            column: 27
          },
          end: {
            line: 81,
            column: 28
          }
        },
        loc: {
          start: {
            line: 81,
            column: 51
          },
          end: {
            line: 106,
            column: 1
          }
        },
        line: 81
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 93,
            column: 10
          },
          end: {
            line: 93,
            column: 11
          }
        },
        loc: {
          start: {
            line: 93,
            column: 22
          },
          end: {
            line: 100,
            column: 5
          }
        },
        line: 93
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 101,
            column: 11
          },
          end: {
            line: 101,
            column: 12
          }
        },
        loc: {
          start: {
            line: 101,
            column: 23
          },
          end: {
            line: 105,
            column: 5
          }
        },
        line: 101
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 110,
            column: 25
          },
          end: {
            line: 110,
            column: 26
          }
        },
        loc: {
          start: {
            line: 110,
            column: 36
          },
          end: {
            line: 110,
            column: 118
          }
        },
        line: 110
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 110,
            column: 36
          },
          end: {
            line: 110,
            column: 37
          }
        },
        loc: {
          start: {
            line: 110,
            column: 60
          },
          end: {
            line: 110,
            column: 118
          }
        },
        line: 110
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 114,
            column: 23
          },
          end: {
            line: 114,
            column: 24
          }
        },
        loc: {
          start: {
            line: 114,
            column: 35
          },
          end: {
            line: 115,
            column: 73
          }
        },
        line: 114
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 114,
            column: 35
          },
          end: {
            line: 114,
            column: 36
          }
        },
        loc: {
          start: {
            line: 115,
            column: 2
          },
          end: {
            line: 115,
            column: 73
          }
        },
        line: 115
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 120,
            column: 13
          },
          end: {
            line: 120,
            column: 14
          }
        },
        loc: {
          start: {
            line: 120,
            column: 25
          },
          end: {
            line: 122,
            column: 1
          }
        },
        line: 120
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 120,
            column: 25
          },
          end: {
            line: 120,
            column: 26
          }
        },
        loc: {
          start: {
            line: 120,
            column: 37
          },
          end: {
            line: 122,
            column: 1
          }
        },
        line: 120
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 127,
            column: 15
          },
          end: {
            line: 127,
            column: 16
          }
        },
        loc: {
          start: {
            line: 127,
            column: 29
          },
          end: {
            line: 129,
            column: 1
          }
        },
        line: 127
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 127,
            column: 29
          },
          end: {
            line: 127,
            column: 30
          }
        },
        loc: {
          start: {
            line: 127,
            column: 41
          },
          end: {
            line: 129,
            column: 1
          }
        },
        line: 127
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 48,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 48,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 45
      },
      "1": {
        loc: {
          start: {
            line: 51,
            column: 2
          },
          end: {
            line: 53,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 51,
            column: 2
          },
          end: {
            line: 53,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 51
      },
      "2": {
        loc: {
          start: {
            line: 51,
            column: 6
          },
          end: {
            line: 51,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 51,
            column: 6
          },
          end: {
            line: 51,
            column: 22
          }
        }, {
          start: {
            line: 51,
            column: 26
          },
          end: {
            line: 51,
            column: 53
          }
        }],
        line: 51
      },
      "3": {
        loc: {
          start: {
            line: 63,
            column: 6
          },
          end: {
            line: 67,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 63,
            column: 6
          },
          end: {
            line: 67,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 63
      },
      "4": {
        loc: {
          start: {
            line: 63,
            column: 10
          },
          end: {
            line: 63,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 63,
            column: 10
          },
          end: {
            line: 63,
            column: 32
          }
        }, {
          start: {
            line: 63,
            column: 36
          },
          end: {
            line: 63,
            column: 57
          }
        }],
        line: 63
      },
      "5": {
        loc: {
          start: {
            line: 72,
            column: 6
          },
          end: {
            line: 74,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 72,
            column: 6
          },
          end: {
            line: 74,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 72
      },
      "6": {
        loc: {
          start: {
            line: 72,
            column: 10
          },
          end: {
            line: 72,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 72,
            column: 10
          },
          end: {
            line: 72,
            column: 18
          }
        }, {
          start: {
            line: 72,
            column: 22
          },
          end: {
            line: 72,
            column: 45
          }
        }],
        line: 72
      },
      "7": {
        loc: {
          start: {
            line: 94,
            column: 6
          },
          end: {
            line: 98,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 94,
            column: 6
          },
          end: {
            line: 98,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 94
      },
      "8": {
        loc: {
          start: {
            line: 94,
            column: 10
          },
          end: {
            line: 94,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 94,
            column: 10
          },
          end: {
            line: 94,
            column: 32
          }
        }, {
          start: {
            line: 94,
            column: 36
          },
          end: {
            line: 94,
            column: 57
          }
        }],
        line: 94
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "00d2d68fb1ad5f40199cac2c57805c7277dc528b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1iax2wxgii = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1iax2wxgii();
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
cov_1iax2wxgii().s[0]++;
var getBeforeLoadAction = function getBeforeLoadAction() {
  cov_1iax2wxgii().f[0]++;
  cov_1iax2wxgii().s[1]++;
  return {
    type: 'CONFIG_BEFORE_LOAD'
  };
};
cov_1iax2wxgii().s[2]++;
var getLoadSuccessAction = function getLoadSuccessAction(data) {
  cov_1iax2wxgii().f[1]++;
  cov_1iax2wxgii().s[3]++;
  return {
    type: 'CONFIG_LOAD_SUCCESS',
    data: data
  };
};
cov_1iax2wxgii().s[4]++;
var getLoadErrorAction = function getLoadErrorAction(data) {
  cov_1iax2wxgii().f[2]++;
  cov_1iax2wxgii().s[5]++;
  return {
    type: 'CONFIG_LOAD_ERROR',
    data: data
  };
};
cov_1iax2wxgii().s[6]++;
var getInitAction = function getInitAction(data) {
  cov_1iax2wxgii().f[3]++;
  cov_1iax2wxgii().s[7]++;
  return {
    type: 'CONFIG_INITIALIZATION',
    data: data
  };
};
cov_1iax2wxgii().s[8]++;
var getUpdateAction = function getUpdateAction(data) {
  cov_1iax2wxgii().f[4]++;
  cov_1iax2wxgii().s[9]++;
  return {
    type: 'CONFIG_UPDATE',
    data: data
  };
};
cov_1iax2wxgii().s[10]++;
var getChangeLanguageAction = function getChangeLanguageAction(language, defaultLanguage) {
  cov_1iax2wxgii().f[5]++;
  cov_1iax2wxgii().s[11]++;
  return {
    type: 'GLOBAL_CHANGE_LANGUAGE',
    language: language,
    defaultLanguage: defaultLanguage
  };
};
cov_1iax2wxgii().s[12]++;
var getCsrfSuccessAction = function getCsrfSuccessAction(data) {
  cov_1iax2wxgii().f[6]++;
  cov_1iax2wxgii().s[13]++;
  return {
    type: 'CSRF_LOAD_SUCCESS',
    data: data
  };
};

/**
 * The loader get the basic configuration, such as style and translations overrides
 * @param {object} configPredefined, contains the config passed from widgets input
 * @param {array} additionalParams, contains the additional fields passed from widgets input
 */
cov_1iax2wxgii().s[14]++;
var load = function load(configPredefined, additionalParams) {
  cov_1iax2wxgii().f[7]++;
  cov_1iax2wxgii().s[15]++;
  return function (dispatch, getState) {
    cov_1iax2wxgii().f[8]++;
    cov_1iax2wxgii().s[16]++;
    // first dispatch the beforeLoad action
    dispatch(getBeforeLoadAction());
    // If pass a config predefined, prevent fetch the configuration making a call
    cov_1iax2wxgii().s[17]++;
    if (configPredefined) {
      cov_1iax2wxgii().b[0][0]++;
      cov_1iax2wxgii().s[18]++;
      dispatch(getLoadSuccessAction(configPredefined));
      cov_1iax2wxgii().s[19]++;
      return configPredefined;
    } else {
      cov_1iax2wxgii().b[0][1]++;
    }
    var additionalFields = (cov_1iax2wxgii().s[20]++, 'style,labelOverrides,session,user');
    cov_1iax2wxgii().s[21]++;
    if ((cov_1iax2wxgii().b[2][0]++, additionalParams) && (cov_1iax2wxgii().b[2][1]++, additionalParams.length > 0)) {
      cov_1iax2wxgii().b[1][0]++;
      cov_1iax2wxgii().s[22]++;
      additionalFields = additionalParams.filter(Boolean).join(',');
    } else {
      cov_1iax2wxgii().b[1][1]++;
    }
    // then fetch the configuration
    cov_1iax2wxgii().s[23]++;
    return (0, _gAxios.default)("".concat(getState().restHost, "/v1/config?additionalFields=").concat(additionalFields), {
      headers: getState().headers,
      withCredentials: true
    }).then(function (response) {
      cov_1iax2wxgii().f[9]++;
      cov_1iax2wxgii().s[24]++;
      if ((cov_1iax2wxgii().b[4][0]++, response.status >= 200) && (cov_1iax2wxgii().b[4][1]++, response.status < 300)) {
        cov_1iax2wxgii().b[3][0]++;
        var data = (cov_1iax2wxgii().s[25]++, _objectSpread(_objectSpread({}, response.data), {}, {
          standardHeaders: response.headers
        }));
        cov_1iax2wxgii().s[26]++;
        dispatch(getLoadSuccessAction(data));
        cov_1iax2wxgii().s[27]++;
        return response.data;
      } else {
        cov_1iax2wxgii().b[3][1]++;
      }
      cov_1iax2wxgii().s[28]++;
      throw response;
    }).catch(function (response) {
      cov_1iax2wxgii().f[10]++;
      var data = (cov_1iax2wxgii().s[29]++, {});
      cov_1iax2wxgii().s[30]++;
      if ((cov_1iax2wxgii().b[6][0]++, response) && (cov_1iax2wxgii().b[6][1]++, response.status === 403)) {
        cov_1iax2wxgii().b[5][0]++;
        cov_1iax2wxgii().s[31]++;
        data.errorCode = 'NOT_AUTHORIZED';
      } else {
        cov_1iax2wxgii().b[5][1]++;
      }
      cov_1iax2wxgii().s[32]++;
      dispatch(getLoadErrorAction(data));
      cov_1iax2wxgii().s[33]++;
      (0, _gAxios.logError)((0, _gAxios.getFrontEndErrorFromAxiosError)(response), getState().headers, getState().widgetInfo, response);
      cov_1iax2wxgii().s[34]++;
      return response;
    });
  };
};
cov_1iax2wxgii().s[35]++;
var getCsrfToken = function getCsrfToken() {
  cov_1iax2wxgii().f[11]++;
  cov_1iax2wxgii().s[36]++;
  return function (dispatch, getState) {
    cov_1iax2wxgii().f[12]++;
    cov_1iax2wxgii().s[37]++;
    // first dispatch the beforeLoad action
    dispatch(getBeforeLoadAction());
    // then fetch the configuration
    cov_1iax2wxgii().s[38]++;
    return (0, _gAxios.default)("".concat(getState().restHost, "/v1/csrf"), {
      headers: getState().headers,
      withCredentials: true,
      credentials: 'include'
    }).then(function (response) {
      cov_1iax2wxgii().f[13]++;
      cov_1iax2wxgii().s[39]++;
      if ((cov_1iax2wxgii().b[8][0]++, response.status >= 200) && (cov_1iax2wxgii().b[8][1]++, response.status < 300)) {
        cov_1iax2wxgii().b[7][0]++;
        var data = (cov_1iax2wxgii().s[40]++, _objectSpread(_objectSpread({}, response.data), {}, {
          standardHeaders: response.headers
        }));
        cov_1iax2wxgii().s[41]++;
        dispatch(getCsrfSuccessAction(data));
        cov_1iax2wxgii().s[42]++;
        return response.data;
      } else {
        cov_1iax2wxgii().b[7][1]++;
      }
      cov_1iax2wxgii().s[43]++;
      throw response;
    }).catch(function (response) {
      cov_1iax2wxgii().f[14]++;
      cov_1iax2wxgii().s[44]++;
      dispatch(getLoadErrorAction());
      cov_1iax2wxgii().s[45]++;
      (0, _gAxios.logError)((0, _gAxios.getFrontEndErrorFromAxiosError)(response), getState().headers, getState().widgetInfo, response);
      cov_1iax2wxgii().s[46]++;
      return response;
    });
  };
};
/*
 * Convenient function to log error on the server
 */
cov_1iax2wxgii().s[47]++;
var logErrorOnServer = function logErrorOnServer(error) {
  cov_1iax2wxgii().f[15]++;
  cov_1iax2wxgii().s[48]++;
  return function (dispatch, getState) {
    cov_1iax2wxgii().f[16]++;
    cov_1iax2wxgii().s[49]++;
    return (0, _gAxios.logError)(error, getState().headers, getState().widgetInfo);
  };
};
/*
 * Change the language of the all application
 */
cov_1iax2wxgii().s[50]++;
var changeLanguage = function changeLanguage(language) {
  cov_1iax2wxgii().f[17]++;
  cov_1iax2wxgii().s[51]++;
  return function (dispatch, getState) {
    cov_1iax2wxgii().f[18]++;
    cov_1iax2wxgii().s[52]++;
    return dispatch(getChangeLanguageAction(language, getState().defaultLanguage));
  };
};

/*
 * Set the basic data we need such as hostname and apiKey
 */
cov_1iax2wxgii().s[53]++;
var init = function init(initData) {
  cov_1iax2wxgii().f[19]++;
  cov_1iax2wxgii().s[54]++;
  return function (dispatch) {
    cov_1iax2wxgii().f[20]++;
    cov_1iax2wxgii().s[55]++;
    dispatch(getInitAction(initData));
  };
};

/*
 * Update data with new values
 */
cov_1iax2wxgii().s[56]++;
var update = function update(updateData) {
  cov_1iax2wxgii().f[21]++;
  cov_1iax2wxgii().s[57]++;
  return function (dispatch) {
    cov_1iax2wxgii().f[22]++;
    cov_1iax2wxgii().s[58]++;
    dispatch(getUpdateAction(updateData));
  };
};
var _default = exports.default = {
  load: load,
  init: init,
  getCsrfToken: getCsrfToken,
  update: update,
  changeLanguage: changeLanguage,
  logError: logErrorOnServer
};